import React from 'react';
import Hero from '../../components/landing/Hero';
import About from '../../components/landing/About';
import Services from '../../components/landing/Services';
import Contact from '../../components/landing/Contact';
import Footer from '../../components/landing/Footer';
import { Box } from '@mui/material';

const Home: React.FC = () => {
  return (
    <Box>
      <Hero />
      <About />
      <Services />
      <Contact />
      <Footer />
    </Box>
  );
};

export default Home;

